import { Component } from 'js-component-framework';
import './mediaTrigger.scss';

export default class MediaTrigger extends Component {
  /**
   * Constructor. Binds function scope.
   * @param {object} props - Props for this component.
   */
  constructor(config) {
    super(config);
    this.activeVideo = '';
    this.onMediaClick = this.onMediaClick.bind(this);
    this.init();
  }

  onMediaClick(item) {
    // we need to rebuild the DOM if the video was already played
    if (this.element && this.activeVideo) {
      const oldEmptyVideo = this.element.querySelector('iframe');
      const newEmptyVideo = document.createElement('div');
      oldEmptyVideo.remove();
      newEmptyVideo.classList.add('empty-video');
      this.element.appendChild(newEmptyVideo);
    }

    const emptyVideo = this.element.querySelector('.empty-video');

    // Code below uses the YouTube IFrame API for more player control.
    // eslint-disable-next-line no-undef
    this.activeVideo = new YT.Player(emptyVideo, {
      height: '375',
      width: '500',
      videoId: item,
      playerVars: {
        rel: 0,
        enablejsapi: 1,
        modestbranding: 1,
        showinfo: 0,
      },
      events: {
        onReady: () => { this.activeVideo.playVideo(); },
        onStateChange: (event) => {
          // video is playing
          if (1 === event.data) {
            event.target.a.classList.add('playing');
          } else {
            event.target.a.classList.remove('playing');
          }
        },
      },
    });
  }

  /**
   * Renders component markup.
   */
  init() {
    const {
      controller,
    } = this.children;

    if (! controller) {
      return;
    }

    controller.addEventListener('click', () => this
      .onMediaClick(this.element.dataset.youtubeId));
  }
}
